/* eslint-disable no-magic-numbers */
import { isEmpty, startsWith } from 'lodash';

export const formatSortCode = (sortCode) => {
  if (!sortCode) return null;
  return `${sortCode.slice(0, 2)}-${sortCode.slice(2, 4)}-${sortCode.slice(-2)}`;
};

export const formatCreditCard = (creditcard) => {
  if (!creditcard) return null;
  return `${creditcard.slice(0, 4)} ${creditcard.slice(4, 8)} ${creditcard.slice(
    8,
    12
  )} ${creditcard.slice(-4)}`;
};

export const fixAmount = (amount = '') => {
  const numericAmount = Number.parseFloat(amount);

  if (Number.isNaN(numericAmount)) return '';

  return numericAmount
    .toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .replace(',', '');
};

export const checkValidation = (amount) => {
  return isEmpty(amount) || startsWith(amount, '.');
};

export const hasPhoneNumber = (userDetails) => {
  let hasPhone = false;
  if (!isEmpty(userDetails.phone_numbers)) {
    hasPhone = userDetails.phone_numbers.some((number) => number.type === 'M');
  }
  return hasPhone;
};
